import { dataMusicSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconMusicSolid = /*#__PURE__*/createIcon(dataMusicSolid)
export default IconMusicSolid
